import { FC, HTMLAttributes } from "react";
import Image from "next/image";
import clsx from "clsx";

import icon, { IIconName } from "@/utils/icon.helper";

// ------------------------------------------------------------------------------------------

export type IContact = {
  icon?: IIconName;
  name?: string;
};

export type IPartnerContactInfoSectionProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  contacts?: IContact[];
};

const PartnerContactInfoSection: FC<IPartnerContactInfoSectionProps> = (
  props,
) => {
  const { heading, contacts, className, ...other } = props;

  const midValue = contacts && Math.ceil(contacts.length / 2);

  const contactListOne = midValue && contacts.slice(0, midValue);
  const contactListTwo = midValue && contacts.slice(midValue);

  return (
    <section
      className={clsx("pt-5 lg:pt-8 xl:pt-[50px]", className)}
      {...other}
    >
      <div className="bg-secondary-50 py-10 lg:py-16 xl:py-[100px]">
        <div className="container">
          {heading && (
            <h2 className="mb-5 text-3xl font-medium text-black-900 md:mb-7 lg:mb-11 lg:text-h2">
              {heading}
            </h2>
          )}
          {contacts && contacts.length > 0 && (
            <div className="flex flex-col gap-x-7 gap-y-5 md:flex-row">
              {contactListOne && contactListOne.length > 0 && (
                <div className="flex w-full flex-col gap-y-5 md:w-1/2 lg:gap-y-7">
                  {contactListOne.map((contact, idx) => (
                    <div
                      key={idx}
                      className="flex w-full items-start gap-5 lg:w-4/5 lg:gap-[30px]"
                    >
                      {/* icon  */}
                      {contact.icon && (
                        <Image
                          className="size-[25px] md:mt-1"
                          src={icon(contact.icon)}
                          alt={contact.icon}
                          width={25}
                          height={25}
                        />
                      )}

                      {contact.name && (
                        <span className="text-base font-normal text-black-900 lg:text-base xl:text-h6">
                          {contact.name}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {contactListTwo && contactListTwo.length > 0 && (
                <div className="flex w-full flex-col gap-y-5 md:w-1/2 lg:gap-y-7">
                  {contactListTwo.map((contact, idx) => (
                    <div
                      key={idx}
                      className="flex items-start gap-5 lg:gap-[30px]"
                    >
                      {contact.icon && (
                        <Image
                          className="size-[25px] md:mt-1"
                          src={icon(contact.icon)}
                          alt={contact.icon}
                          width={25}
                          height={25}
                        />
                      )}
                      {contact.name && (
                        <span className="text-base font-normal text-black-900 lg:text-base xl:text-h6">
                          {contact.name}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default PartnerContactInfoSection;
